
// ClientesPage

import React, { useState, useEffect } from 'react';
import Header from '../../components/Header.js';
import { useTheme } from '../../contexts/ThemeContext.js';
import ExibirCliente from '../../components/ExibirCliente.js';
import CadastrarCliente from '../../components/CadastrarCliente.js';
import EditarCliente from '../../components/EditarCliente.js';
import ListarClientes from '../../components/ListarClientes.js';
import BotoesdeNavegacao from '../../components/BotoesdeNavegacao.js';
import BotoesDeAcao from '../../components/BotoesDeAcao.js';
import { useNavigate } from 'react-router-dom';
//import Axios from 'axios';
import api from '../../config/axiosConfig'; 

import '../../App.css';

function ClientesPage() {
  const { theme } = useTheme();
  const [clientes, setClientes] = useState([]);
  const [selectedCliente, setSelectedCliente] = useState(null);
  const [showCadastroCliente, setShowCadastroCliente] = useState(false);
  const [showEditaCliente, setShowEditaCliente] = useState(false);
  const [showExibeCliente, setShowExibeCliente] = useState(false);
  const [showListaClientes, setShowListaClientes] = useState(false); // Estado para controlar a exibição do componente ListarClientes
  // eslint-disable-next-line no-unused-vars
  const [currentPage, setCurrentPage] = useState(1);
  // eslint-disable-next-line no-unused-vars
  const [totalPages, setTotalPages] = useState(1); // Inicialmente 1 página
  const [isSearchVisible, setIsSearchVisible] = useState(false);
  const [searchQuery, setSearchQuery] = useState({ codigo: '', nome: '', cnpj: '' });
  const navigate = useNavigate(); // Definindo o useNavigate


// Função para carregar os clientes
const loadClientes = async (pageNumber = 1) => {
  console.log('Primeiro Cliente Carregado-01:');
  try {
  
  const response = await api.get(`/clientes/listarclientes/paginados?page=${pageNumber - 1}&size=10`);
  //{
  //headers: {
  //  Authorization: `Bearer ${localStorage.getItem('token')}`
  //}
  //});
    
    setClientes(response.data.content);
    
    // Calcular o número total de páginas com base na quantidade de clientes e o tamanho da página
    const totalClientes = response.data.totalElements;
    const pageSize = 10; // Tamanho fixo da página
    const totalPages = Math.ceil(totalClientes / pageSize);
    
    setTotalPages(totalPages);

    if (!selectedCliente && response.data.content.length > 0) {
      setSelectedCliente(response.data.content[0]);
      setShowExibeCliente(true);
    }
  } catch (error) {
    console.error('Erro ao carregar clientes:', error);
  }
};


// Função para exibir o cliente selecionado
const handleCodigoClick = async (clienteCodcli) => {
  try {
    // Fechar o componente ListarClientes
    handleSairListarClick();

    // Buscar o cliente Selecionado
    const response = await api.get(`/clientes/buscarcliente?codcli=${clienteCodcli}`);
  //{
  //headers: {
  //  Authorization: `Bearer ${localStorage.getItem('token')}`
  //}
  //}
  //);
    
    if (response.data && response.data.length > 0) {
      const cliente = Array.isArray(response.data) ? response.data[0] : response.data;
      setSelectedCliente(cliente);
      setShowExibeCliente(true);
    } else {
      window.alert('Cliente não encontrado.');
    }
  } catch (error) {
    console.error('Erro ao buscar cliente:', error);
    window.alert('Erro ao buscar cliente. Verifique o console para mais detalhes.');
  }
};
  
// Funções de navegação
// Função para buscar o primeiro cliente

  const fetchPrimeiroCliente = async () => {
  try {
    const response = await api.get('/clientes/primeiro');

    if (response.data && response.data.codcli) {
      console.log('Primeiro Cliente encontrado:', response.data);
      setSelectedCliente(response.data);
      setShowExibeCliente(true);
    } else {
      console.log('Nenhum cliente cadastrado');
      setSelectedCliente(null);
      setShowExibeCliente(false);
      window.alert('Nenhum cliente cadastrado.');
    }
  } catch (error) {
    console.error('Erro ao buscar o primeiro cliente:', error);
    setSelectedCliente(null);
    setShowExibeCliente(false);
    window.alert('Erro ao buscar o primeiro cliente.');
  }
};
  
// Função para buscar o cliente anterior
const fetchClienteAnterior = async () => {
  if (selectedCliente && selectedCliente.id) {
    console.log('Buscando cliente anterior para o ID:', selectedCliente.id);
    try {
      const response = await api.get(`/clientes/anterior/${selectedCliente.id}`);
  //  , {
  //headers: {
  //Authorization: `Bearer ${localStorage.getItem('token')}`
  //}
  //});
      
      if (response.data) {
        console.log('Cliente anterior encontrado:', response.data);
        setSelectedCliente(response.data);
        setShowExibeCliente(true);
      } else {
        console.warn('Nenhum cliente anterior encontrado.');
      }
    } catch (error) {
      console.error('Erro ao buscar o cliente anterior:', error);
    }
  } else {
    console.error('Nenhum cliente selecionado ou cliente sem ID');
  }
};

  
// Função para buscar o cliente posterior
const fetchClientePosterior = async () => {
  if (selectedCliente && selectedCliente.id) {
      console.log('Buscando cliente posterior para o ID:', selectedCliente.id); // Log do ID do cliente selecionado
    try {
      const response = await api.get(`/clientes/proximo/${selectedCliente.id}`);
  // , {
  //headers: {
  //Authorization: `Bearer ${localStorage.getItem('token')}`
  //}
  //});

      if (response.data) {
        console.log('Cliente posterior encontrado:', response.data); // Log do cliente posterior encontrado
        setSelectedCliente(response.data);
        setShowExibeCliente(true);
        } else {
          console.warn('Nenhum cliente posterior encontrado.');
        }
      } catch (error) {
        console.error('Erro ao buscar o cliente posterior:', error);
      }
    } else {
      console.error('Nenhum cliente selecionado ou cliente sem ID');
    }
  };
  

// Função para buscar o último cliente
const fetchUltimoCliente = async () => {
  try {
    const response = await api.get('/clientes/ultimo');
  //, {
  //headers: {
  //Authorization: `Bearer ${localStorage.getItem('token')}`
  //}
  //});

    if (response.data) {
      console.log('Último Cliente encontrado:', response.data);
      setSelectedCliente(response.data);
      setShowExibeCliente(true);
    }
  } catch (error) {
    console.error('Erro ao buscar o último cliente:', error);
  }
};

// Efeito para carregar o primeiro cliente quando o componente for montado
  useEffect(() => {
  fetchPrimeiroCliente();
  }, []);


  // Função para Buscar Cliente pelo código
  const fetchClientePorCodigo = async (codcli) => {
    console.log('Buscando cliente pelo Código:');
    try {
      const response = await api.get(`/clientes/buscarcliente?codcli=${codcli}`);
  //, {
  //headers: {
  //Authorization: `Bearer ${localStorage.getItem('token')}`
  //}
  //});
  
      if (response.data && response.data.length > 0) {
        const cliente = Array.isArray(response.data) ? response.data[0] : response.data;
        console.log('Cliente encontrado por Código:', cliente);
        window.alert('Cliente encontrado por Código:', cliente);
        setSelectedCliente(cliente);
        setShowExibeCliente(true);
      } else {
        window.alert('Cliente Não Encontrado, Verifique a Busca.');
        fetchPrimeiroCliente();
      }
    } catch (error) {
      console.error('Erro ao buscar cliente por Código:', error);
      window.alert('Cliente Não Encontrado, Verifique a Busca.');
      fetchPrimeiroCliente();
    }
  };


  // Função para Buscar Cliente pelo Nome
  const fetchClientePorNome = async (nomecli) => {
    console.log('Buscando cliente pelo Nome:');
    try {
      const response = await api.get(`/clientes/buscarcliente?nomecli=${nomecli}`);
  //, {
  //headers: {
  //Authorization: `Bearer ${localStorage.getItem('token')}`
  //}
  //});
  
      if (response.data && response.data.length > 0) {
        const cliente = Array.isArray(response.data) ? response.data[0] : response.data;
        console.log('Cliente encontrado por Nome:', cliente);
        window.alert('Cliente encontrado por Nome:', cliente);
        setSelectedCliente(cliente);
        setShowExibeCliente(true);
      } else {
        window.alert('Cliente Não Encontrado, Verifique a Busca.');
        fetchPrimeiroCliente();
      }
    } catch (error) {
      console.error('Erro ao buscar cliente por Nome:', error);
      window.alert('Cliente Não Encontrado, Verifique a Busca.');
      fetchPrimeiroCliente();
    }
  };


  // Função para Buscar Cliente pelo CNPJ
  const fetchClientePorCNPJ = async (cnpjcli) => {
    console.log('Buscando cliente pelo CNPJ:');
    try {
      const response = await api.get(`/clientes/buscarcliente?cnpjcli=${cnpjcli}`);
  //, {
  //headers: {
  //Authorization: `Bearer ${localStorage.getItem('token')}`
  //}
  //});
  
      if (response.data && response.data.length > 0) {
        const cliente = Array.isArray(response.data) ? response.data[0] : response.data;
        console.log('Cliente encontrado pelo CNPJ:', cliente);
        window.alert('Cliente encontrado pelo CNPJ:', cliente);
        setSelectedCliente(cliente);
        setShowExibeCliente(true);
      } else {
        window.alert('Cliente Não Encontrado, Verifique a Busca.');
        fetchPrimeiroCliente();
      }
    } catch (error) {
      console.error('Erro ao buscar cliente por CNPJ:', error);
      window.alert('Cliente Não Encontrado, Verifique a Busca.');
      fetchPrimeiroCliente();
    }
  };

  // Função para listar Clientes Cadastrados
    const handleListarClick = () => {
    setShowListaClientes(true); // Ao clicar no botão Listar, mostrar o componente ListarClientes
    setShowExibeCliente(false); // Esconder o componente ExibirCliente
  };

  // Função para sair do Listar Clientes
  const handleSairListarClick = () => {
    setShowListaClientes(false); // Ao clicar no botão Sair do ListarClientes, esconder o componente ListarClientes
    setShowExibeCliente(true); // Mostrar novamente o componente ExibirCliente
  };


  // Função para cadastrar Novo Cliente
  const handleNovoClick = () => {
    setSelectedCliente(null);
    setShowCadastroCliente(true);
    setShowEditaCliente(false);
    setShowExibeCliente(false);
  };

  // Função para Salvar Cadstro Novo Cliente
  const handleClienteSalvo = (clienteSalvo) => {
    setClientes([...clientes, clienteSalvo]);
    setSelectedCliente(clienteSalvo);
    setShowExibeCliente(true);
    setShowCadastroCliente(false);
    window.alert('Cliente Novo Salvo com Sucesso');
  };


  // Função para Editar Cliente Selecionado
  const handleEditClick = () => {
    setShowEditaCliente(true);
    setShowCadastroCliente(false);
    setShowExibeCliente(false);
  };

  // Função para Salvar Cliente Editado
  const handleClienteEditado = (clienteSalvo) => {
    setClientes([...clientes, clienteSalvo]);
    setSelectedCliente(clienteSalvo);
    setShowExibeCliente(true);
    setShowEditaCliente(false);
    window.alert('Cliente Editado com Sucesso');
  };

  // Função para cancelar o Cadastro do Cliente
  const handleCancelar = () => {
    setShowCadastroCliente(false);
    fetchPrimeiroCliente(); // Carrega o primeiro cliente da lista
    setShowExibeCliente(true);
  };

  // Função para cancelar a Edição do Cliente
  const handleCancelaEdit = () => {
    setShowCadastroCliente(false);
    setShowEditaCliente(false);
    setShowExibeCliente(true);
  };

  // Função para cancelar a Exibição do Cliente
  const handleCancelaExibe = () => {
    setShowCadastroCliente(false);
    setShowEditaCliente(false);
    setShowExibeCliente(false);
    setClientes(null); // Reseta o estado da venda
    navigate('/home'); // Redireciona para a página inicial
  };


    // Função para Excluir o Cliente
  const handleDeleteClick = async () => {
    if (selectedCliente) {
      const confirmation = window.confirm(`Tem certeza que deseja excluir o cliente ${selectedCliente.nomecli}?`);
      if (confirmation) {
        try {
          await api.delete(`/clientes/excluircliente/${selectedCliente.id}`);
  //, {
  //headers: {
  //Authorization: `Bearer ${localStorage.getItem('token')}`
  //}
  //});

          // window.alert('Cliente excluído com sucesso.');
          window.alert(`Cliente: ${selectedCliente.nomecli} Excluido com Sucesso.`);
        // Carregar clientes novamente
        loadClientes(currentPage);
        // Buscar e exibir o primeiro cliente
        fetchPrimeiroCliente();
        } catch (error) {
          console.error('Erro ao excluir cliente:', error);
        }
      }
    } else {
      console.error('Nenhum cliente selecionado para excluir');
    }
  };


// Se os campos de busca estiverem sendo exibidos, limpa os campos de busca
  const handleSearchClick = () => {
    if (!isSearchVisible) {
    setSearchQuery({ codcli: '', nomecli: '', cnpjcli: '' });
  }
    setIsSearchVisible(!isSearchVisible);
  };
  

// A função handleSearchChange faz a busca apenas quando a tecla Enter é pressionada
  const handleSearchChange = (e) => {
    const { name, value } = e.target;
    setSearchQuery({ ...searchQuery, [name]: value });
  };


  
const handleSearchByCodigo = (e) => {
  if (e.key === 'Enter') {
    fetchClientePorCodigo(searchQuery.codigo);
  }
};

const handleSearchByNome = (e) => {
  if (e.key === 'Enter') {
    fetchClientePorNome(searchQuery.nome);
  }
};

const handleSearchByCNPJ = (e) => {
  if (e.key === 'Enter') {
    fetchClientePorCNPJ(searchQuery.cnpj);
  }
};
  

  return (
    <div
      style={{
        backgroundColor: theme.background,
        color: theme.color,
        minHeight: 'calc(100vh - 20px)',
        width: '100%',
        paddingTop: '10px',
        textAlign: 'center',
      }}
    >
      <Header selectedCompany={localStorage.getItem('selectedCompany')} />

      {showCadastroCliente && (
        <CadastrarCliente
          handleClienteSalvo={handleClienteSalvo}
          handleCancelar={handleCancelar}
          cliente={selectedCliente}
        />
      )}

      {!showCadastroCliente && selectedCliente && !showEditaCliente && showExibeCliente && (
      <>
      <BotoesdeNavegacao
      fetchPrimeiro={fetchPrimeiroCliente}
      fetchAnterior={fetchClienteAnterior}
      fetchProximo={fetchClientePosterior}
      fetchUltimo={fetchUltimoCliente}
      />
      <BotoesDeAcao
      handleNovoClick={handleNovoClick}
      handleEditClick={handleEditClick}
      handleDeleteClick={handleDeleteClick}
      handleSearchClick={handleSearchClick}
      handleListarClick={handleListarClick} // Verifique se handleListarClick está passada corretamente
      isSearchVisible={isSearchVisible}
      handleSearchChange={handleSearchChange}
      handleSearchByCodigo={handleSearchByCodigo}
      handleSearchByNome={handleSearchByNome}
      handleSearchByCNPJ={handleSearchByCNPJ}
      searchQuery={searchQuery}
      />
          
      <ExibirCliente cliente={selectedCliente}
        handleCancelaExibe={handleCancelaExibe}
      />
      </>
      )}

      
      {showListaClientes && (
        <ListarClientes
        onCodigoClick={handleCodigoClick} // Corrigindo para passar a função onCodigoClick
        handleSairListarClick={handleSairListarClick}
        />
      )}


      {showEditaCliente && (
      <EditarCliente
      cliente={selectedCliente}
      handleClienteEditado={handleClienteEditado}
      handleCancelaEdit={handleCancelaEdit}
      />
      )}
      
  </div>
  );
}

export default ClientesPage;

